/* global dataLayer */

import { useEffect } from 'react';

const pushChangeEvent = evt => {
  if (!dataLayer) {
    return;
  }
  dataLayer.push({ event: 'Change', changeElement: evt.target });
};

const useGtmDataLayer = () => {
  useEffect(() => {
    document.addEventListener('change', pushChangeEvent);
    return () => document.removeEventListener('change', pushChangeEvent);
  }, []);
};

export default useGtmDataLayer;
